import React, { useState, useEffect } from "react";
import { Button, Grid, Typography, TextField, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../../../context/AuthContext";

const TopMenu = ({
  heading,
  setAddData,
  setData,
  setDrawerFilterOpen,
  filterApplied,
  searchQuery,
  setSearchQuery,
}) => {
  const { user } = useUser();

  const location = useLocation();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("Upstream");
  const [button, setButton] = useState("");

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("upstream")) {
      setSelectedOption("Upstream");
      setButton("Upstream");
    } else if (path.includes("downstream")) {
      setSelectedOption("Downstream");
      setButton("Downstream");
    }
  }, [location]);

  const handleToggle = (option) => {
    setSelectedOption(option);
    setButton(option);

    // Navigate to the respective route
    if (option === "Upstream") {
      navigate("/value-chain-partner/upstream");
    } else {
      navigate("/value-chain-partner/downstream");
    }
  };

  return (
    <Box sx={{ width: "100%", margin: "1rem 0" }}>
      {/* Title */}
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "black", marginBottom: "1rem" }}
      >
        {heading}
      </Typography>

      {/* Search Bar and Filter/Add Buttons */}
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={10} md={4}>
          <TextField
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="🔍 Search"
            fullWidth
            size="small"
            variant="outlined"
            sx={{ backgroundColor: "#FFFFFF", borderRadius: "4px" }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
          sx={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
        >
          <Button
            variant="contained"
            onClick={() => setDrawerFilterOpen(true)}
            sx={{
              backgroundColor: "#FFFFFF",
              color: "black",
              textTransform: "none",
              "&:hover": { backgroundColor: "#1C486B", color: "#FFFFFF" },
              "&:hover .dot-icon": { color: "#FFFFFF" },
            }}
          >
            FILTER
            <FilterListIcon />
            {filterApplied && (
              <FiberManualRecordIcon
                className="dot-icon"
                sx={{ fontSize: "10px", color: "#488257", marginLeft: "5px" }}
              />
            )}
          </Button>
          {!user?.companyAdmin && (
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              sx={{
                backgroundColor: "#1C486B",
                color: "#FFFFFF",
                fontSize: "14px",
                textTransform: "none",
                "&:hover": { backgroundColor: "#123A55" },
              }}
              onClick={() => {
                setAddData(true);
                setData(null);
              }}
            >
              Add New
            </Button>
          )}
        </Grid>
      </Grid>

      {/* Upstream and Downstream Buttons */}
      <Grid container sx={{ marginTop: "1rem" }}>
        <Grid item xs={12} sx={{ display: "flex", gap: "1rem" }}>
          <Button
            variant={button === "Upstream" ? "contained" : "outlined"}
            onClick={() => handleToggle("Upstream")}
            sx={{
              backgroundColor: button === "Upstream" ? "#1C486B" : "#ededed",
              color: button === "Upstream" ? "#ededed" : "#1C486B",
              borderColor: "#1C486B",
              textTransform: "none",
              "&:hover": {
                backgroundColor: button === "Upstream" ? "#123A55" : "#F0F8FF",
              },
            }}
          >
            Upstream
          </Button>
          <Button
            variant={button === "Downstream" ? "contained" : "outlined"}
            onClick={() => handleToggle("Downstream")}
            sx={{
              backgroundColor: button === "Downstream" ? "#1C486B" : "#ededed",
              color: button === "Downstream" ? "#ededed" : "#1C486B",
              borderColor: "#1C486B",
              textTransform: "none",
              "&:hover": {
                backgroundColor:
                  button === "Downstream" ? "#123A55" : "#F0F8FF",
              },
            }}
          >
            Downstream
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TopMenu;
